import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import {
  MAX_IMAGE_CONTRAST,
  MIN_IMAGE_CONTRAST,
  DEFAULT_OPT_IMAGE_CONTRAST,
  hasTopconLoadedStack,
} from "../utils/imageContrast";

export default function ImageContrastControls() {
  const dispatch = useDispatch();
  const dicomData = useSelector((state) => state.dcm);
  const imageContrast = useSelector((state) => state.dcm.settings.imageContrast);

  const contrastValue = imageContrast?.value ?? DEFAULT_OPT_IMAGE_CONTRAST;
  const showControls = hasTopconLoadedStack(dicomData);

  const onSliderChange = (_event, value) => {
    dispatch({
      type: "SET_IMAGE_CONTRAST_VALUE",
      value,
    });
  };

  if (!showControls) {
    return null;
  }

  return (
    <Box
      sx={{
        px: 1.5,
        py: 1.5,
        bgcolor: "#e8eaed",
        borderBottom: "1px solid #cdd1d6",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{ mb: 1, color: "text.primary", fontWeight: 600 }}
      >
        OPT contrast (Topcon)
      </Typography>

      <Slider
        value={contrastValue}
        min={MIN_IMAGE_CONTRAST}
        max={MAX_IMAGE_CONTRAST}
        step={1}
        size="small"
        onChange={onSliderChange}
        sx={{
          mt: 0.5,
          "& .MuiSlider-track": { backgroundColor: "#1976d2" },
          "& .MuiSlider-rail": { backgroundColor: "#e0e0e0", opacity: 1 },
          "& .MuiSlider-thumb": {
            backgroundColor: "#1976d2",
            border: "2px solid #fff",
          },
        }}
      />

      <Typography
        variant="body2"
        sx={{ textAlign: "center", color: "text.primary", fontWeight: 600 }}
      >
        {contrastValue}
      </Typography>
    </Box>
  );
}
